import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './FandOMostAttractiveContracts.css';
import { useNavigate } from "react-router-dom";
import { Vortex } from 'react-loader-spinner'
import { format, parseISO } from 'date-fns';

function FandOMostAttractiveContracts() {
    const [data, setData] = useState([]);
    const [optBtn, setOpteBtn] = useState("G");
    const [expDate, setExpDate] = useState("-");
    const [instrType, setInstrType] = useState("futidx");
    let navigate = useNavigate();
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData;

    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "Mostactivecontracts";
        fetch(`${getUrl}/MR/${instrType}/-/-/-/${optBtn}/8`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false)
                //console.log(getData, "getData")
            })
            .catch((error) => {
            });
    }, [optBtn, instrType]);

    const moreContent = () => {
        navigate("/Futures-And-Options/Most-Active-Contracts")
    }

    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>Most Attractive Contracts</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className=''>
                        <div className="dropdowndivCon">
                            <div className='most-attr-toggle'>
                                <button value="G" className={(optBtn === "G") ? "active" : ''} onClick={(event) => { setOpteBtn(event.target.value) }}>Gainers</button>
                                <button value="L" className={(optBtn === "L") ? "active" : ''} onClick={(event) => { setOpteBtn(event.target.value) }}>Losers</button>
                                <button value="Val" className={(optBtn === "Val") ? "active" : ''} onClick={(event) => { setOpteBtn(event.target.value) }}>Value Toppers</button>
                                <button value="Vol" className={(optBtn === "Vol") ? "active" : ''} onClick={(event) => { setOpteBtn(event.target.value) }}>Volume Toppers</button>
                            </div>
                            <div className='contract-option'>
                                <div className='most-attr-select'>
                                    
                                    {/* aria-label="Index Futures" */}
                                    <select aria-label="Index Futures" onChange={(event) => { setInstrType(event.target.value) }}>
                                        <option value="futidx">Index Futures</option>
                                        <option value="futstk">Stock Futures</option>
                                        <option value="optidx">Index Options</option>
                                        <option value="optstk">Stock Options</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* tabIndex={0} */}
                        <div className='gainer-table table-responsivePut' tabIndex={0}>
                            <table className='table'>
                                {(() => {
                                    if (optBtn === "Val") {
                                        return (
                                            <><thead>
                                                <tr>
                                                    <th className='text-left'>Contract</th>
                                                    <th className='text-right'>Expiry Date</th>
                                                    <th className='text-right'>LTP(Rs.)</th>
                                                    {(instrType === "optidx") ? <th className='text-right'>Strike Price</th> : ''}
                                                    {(instrType === "optstk") ? <th className='text-right'>Strike Price</th> : ''}
                                                    <th className='text-right'>Change(%)</th>
                                                    <th className='text-right'>Value</th>
                                                    <th className='text-right'>Open Interest</th>
                                                </tr>
                                            </thead>
                                                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                                <tbody>
                                                    {(data != null) && data.map(
                                                        ({ Symbol, LTP, FaOchg, OI, ExpDate, Value, StrikePrice }) => (
                                                            <tr>
                                                                <td className="text-left">{Symbol}</td>
                                                                <td className="text-right">{format(parseISO(ExpDate.split('T')[0] != null ? ExpDate.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                                                                <td className="text-right"> {(LTP != null) ? LTP.toFixed(2) : 0}</td>
                                                                {(instrType === "optidx") ? <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> :''}
                                                                {(instrType === "optstk") ? <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> :''}
                                                                <td className={(FaOchg > 0) ? "textGreen text-right" : "textRed text-right"}> {(FaOchg != null) ? FaOchg.toFixed(2) : 0}</td>
                                                                <td className="text-right"> {(Value != null) ? Value.toFixed(2) : 0}</td>
                                                                <td className="text-right"> {(OI != null) ? OI.toFixed(2) : 0}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </>
                                        )
                                    }
                                    else if (optBtn === "Vol") {
                                        return (
                                            <><thead>
                                                <tr>
                                                    <th className='text-left'>Contract</th>
                                                    <th className='text-right'>Expiry Date</th>
                                                    <th className='text-right'>LTP(Rs.)</th>
                                                    {(instrType === "optidx") ? <th className='text-right'>Strike Price</th> : ''}
                                                    {(instrType === "optstk") ? <th className='text-right'>Strike Price</th> : ''}
                                                    <th className='text-right'>Change(%)</th>
                                                    <th className='text-right'>Volume</th>
                                                    <th className='text-right'>Open Interest</th>
                                                </tr>
                                            </thead>
                                                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                                <tbody>
                                                    {(data != null) && data.map(
                                                        ({ Symbol, LTP, FaOchg, OI, ExpDate, Qty, StrikePrice }) => (
                                                            <tr>
                                                                <td className="text-left">{Symbol}</td>
                                                                <td className="text-right">{format(parseISO(ExpDate.split('T')[0] != null ? ExpDate.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                                                                <td className="text-right"> {(LTP != null) ? LTP.toFixed(2) : 0}</td>
                                                                {(instrType === "optidx") ? <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> :''}
                                                                {(instrType === "optstk") ? <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> :''}
                                                                <td className={(FaOchg > 0) ? "textGreen text-right" : "textRed text-right"}> {(FaOchg != null) ? FaOchg.toFixed(2) : 0}</td>
                                                                <td className="text-right"> {(Qty != null) ? Qty.toFixed(2) : 0}</td>
                                                                <td className="text-right"> {(OI != null) ? OI.toFixed(2) : 0}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </>)

                                    }

                                    else {
                                        return (
                                            <><thead>
                                                <tr>
                                                    <th className='text-left'>Contract</th>
                                                    <th className='text-right'>Expiry Date</th>
                                                    <th className='text-right'>LTP(Rs.)</th>
                                                    {(instrType === "optidx") ? <th className='text-right'>Strike Price</th> : ''}
                                                    {(instrType === "optstk") ? <th className='text-right'>Strike Price</th> : ''}
                                                    <th className='text-right'>Change(%)</th>
                                                    <th className='text-right'>Open Interest</th>
                                                </tr>
                                            </thead>
                                                {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
                                                <tbody>
                                                    {(data != null) && data.map(
                                                        ({ Symbol, LTP, FaOchg, OI, ExpDate, StrikePrice }) => (
                                                            <tr>
                                                                <td className="text-left">{Symbol}</td>
                                                                <td className="text-right">{format(parseISO(ExpDate.split('T')[0] != null ? ExpDate.split('T')[0] :0), 'dd-MMM-yyyy') }</td>
                                                                <td className="text-right"> {(LTP != null) ? LTP.toFixed(2) : 0}</td>
                                                                {(instrType === "optidx") ? <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> :''}
                                                                {(instrType === "optstk") ? <td className="text-right"> {(StrikePrice != null) ? StrikePrice.toFixed(2) : 0}</td> :''}
                                                                <td className={(FaOchg > 0) ? "textGreen text-right" : "textRed text-right"}> {(FaOchg != null) ? FaOchg.toFixed(2) : 0}</td>
                                                                <td className="text-right"> {(OI != null) ? OI.toFixed(2) : 0}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </>)

                                    }

                                })()}
                            </table>
                            {loadingshow ? <div className="textcentervertex">
                                <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </div>
                    </div>
                </Container >
            </div>
        </>
    );
}

export default FandOMostAttractiveContracts;